// Configuración centralizada de la API
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://conexapi.fundacionnigma.org';

// Helper para construir URLs de API
export const buildApiUrl = (endpoint) => {
  const cleanEndpoint = endpoint.startsWith('/api') ? endpoint : `/api${endpoint}`;
  const baseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
  const endpointUrl = cleanEndpoint.startsWith('/') ? cleanEndpoint : `/${cleanEndpoint}`;
  return `${baseUrl}${endpointUrl}`;
};

// Helper para hacer peticiones con autenticación
export const fetchWithAuth = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  const url = buildApiUrl(endpoint);

  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers,
    },
    ...options,
  };
  const response = await fetch(url, config);

  if (response.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    window.location.href = '/login';
    throw new Error('Token expirado o inválido');
  }

  return response;
};

// Función para mapear roles a nombres de display
export const getRolDisplayName = (rol) => {
  switch (rol) {
    case 'administrador':
      return 'Emprendedor';
    case 'conexadmin':
      return 'AdminC';
    case 'trabajador':
    case 'trabajadores':
      return 'Trabajador';
    default:
      return rol;
  }
};
